import { Grid } from "@mui/material";
import { IChequeImage } from "./IChequeCard";
import AttachmentFileModal from "../modal/attachmentFileModal/attachmentFileModal";
import { useEffect, useState } from "react";
import React from "react";


export default function ChequeCardImage({ fileUrl, title }: IChequeImage) {

    const [openModal, setOpenModal] = useState(false)

    const handleClick = () => {
        if (fileUrl != "") {
            setOpenModal(true)
        }
    }

    return (
        <Grid
            className='borderColorPrimaryColorLight-300'
            style={{
                border: '1.5px solid ',
                height: "120px",
                // margin: 'auto',
                borderRadius: '5px',
                background: '#fff',
                alignContent: 'center',
                marginTop: '10px',
                marginBottom: '10px',
            }}
            container
            spacing={0}

        >
            <Grid item xs={4} style={{ alignSelf: "center", paddingRight: "20px", fontSize: "14px", fontWeight: "bold" }} className="primaryColorLight-900">
                <span>{title}</span>

            </Grid>
            <Grid item xs={8} spacing={0} style={{ width: "inherit", height: "inherit", alignSelf: "flex-end" }} >
                <div onClick={handleClick} style={{ width: "inherit", height: "inherit", paddingBottom: "10px", paddingTop: "10px", display: "flex", justifyContent: "flex-end", paddingLeft: "10px" }}>
                    {/* className="imageUpload" */}
                    {fileUrl ? <img
                        style={{
                            maxHeight: '100%',
                            height: '100%'
                        }}
                        className="text-center block"
                        src={fileUrl}
                    /> :
                        <div style={{
                            borderRadius: '5px',
                            background: '#F5F6FA',
                            height: '100%',
                            width: '50%',
                            alignContent: "center"
                        }}>
                            <img
                                style={{ margin: "0 auto" }}
                                className="text-center block"
                                src='/images/emptyImage.png'
                            />
                        </div>}

                </div>
            </Grid>
            <AttachmentFileModal openModal={openModal} file={fileUrl} fileName={"تصویر " + title} setOpenModal={setOpenModal}></AttachmentFileModal>

        </Grid>
    )
}